import { SxProps, Theme } from "@mui/material/styles";

import { MenuItemProps } from "./types";

type MenuItemColor = NonNullable<MenuItemProps["color"]>;
type MenuItemSize = NonNullable<MenuItemProps["size"]>;

const disabledStyles = (theme: Theme) => ({
  "&.Mui-disabled": {
    opacity: "unset",
    color: theme.palette.neutralVariant[80],
    fill: theme.palette.neutralVariant[80],
    background: "unset",
    backgroundColor: "unset",
    "&:hover": {
      color: theme.palette.neutralVariant[80],
      fill: theme.palette.neutralVariant[80],
      background: "unset",
      backgroundColor: "unset",
    },
  },
});

const colorStyles = (theme: Theme, color: MenuItemColor) => {
  switch (color) {
    case "primary":
    case "secondary": {
      const hover = { background: theme.palette[color].lightest };
      return {
        color: theme.palette.neutralVariant[20],
        fill: theme.palette.neutralVariant[20],
        "&.Mui-selected": {
          background: theme.palette[color].lighter,
          color: theme.palette.primary.main,
          "&:hover": hover,
        },
        "&:hover": hover,
      };
    }
    case "error": {
      const hover = { background: theme.palette.error.lightest };
      return {
        color: theme.palette.error.main,
        fill: theme.palette.error.main,
        "&.Mui-selected": {
          background: theme.palette.error.lighter,
          "&:hover": hover,
        },
        "&:hover": hover,
      };
    }
    default: {
      const hover = {
        background: theme.palette.neutralVariant[99],
        backgroundColor: theme.palette.neutralVariant[99],
      };
      return {
        color: theme.palette.neutralVariant[20],
        fill: theme.palette.neutralVariant[20],
        "&.Mui-selected": {
          background: theme.palette.primary.lightest,
          "&:hover": hover,
        },
        "&:hover": hover,
      };
    }
  }
};

export const getMenuItemSx =
  (color: MenuItemColor, size: MenuItemSize): SxProps<Theme> =>
  (theme: Theme) => {
    const colors = colorStyles(theme, color);
    return {
      justifyContent: "space-between",
      paddingTop: "8px",
      paddingRight: "16px",
      paddingBottom: "8px",
      paddingLeft: "16px",
      ...(size === "medium" ? theme.typography.body1 : theme.typography.body2),
      ...colors,
      "&.Mui-selected": {
        ...(size === "medium" ? theme.typography.subtitle1 : theme.typography.subtitle2),
        ...colors["&.Mui-selected"],
      },
      ...disabledStyles(theme),
    };
  };

export const menuItemContentSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  width: "100%",
};
